import React from "react";

const Spacer = ({ size }) => {
  return <div className={`spacer spacer-${size}`}></div>;
};

export default Spacer;
